import { select, selectAll } from "../core/dom";

function animateCounter(element: HTMLElement, target: number, duration: number): void {
  const startedAt = performance.now();

  const update = (currentTime: number): void => {
    const progress = Math.min((currentTime - startedAt) / duration, 1);
    const easedProgress = 1 - Math.pow(1 - progress, 3);

    element.textContent = String(Math.floor(easedProgress * target));

    if (progress < 1) {
      requestAnimationFrame(update);
    } else {
      element.textContent = String(target);
    }
  };

  requestAnimationFrame(update);
}

export function initQualityCounter(): void {
  const section = select<HTMLElement>("#engineering-quality");
  if (!section) return;

  const counters = selectAll<HTMLElement>(".quality-score-value", section);
  if (counters.length === 0) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry?.isIntersecting) return;

      counters.forEach((counter, index) => {
        const target = Number(counter.dataset.target ?? 100);
        window.setTimeout(() => animateCounter(counter, target, 900), index * 120);
      });

      observer.disconnect();
    },
    { threshold: 0.35 }
  );

  observer.observe(section);
}
